import { createSlice } from '@reduxjs/toolkit';

import { getProducts } from '../utils/fetchSFCCproducts';

const appSlice = createSlice({
  name: 'app',
  initialState: {
    initialized: false,
    loading: {},
    products: {}
  },
  reducers: {
    setInitialized(state, action) {
      state.initialized = action.payload;
    },
    fetchStart(state, action) {
      if (action.payload.constructor === Array) {
        action.payload.forEach((id) => {
          state.loading[id] = true;
        });
      } else {
        state.loading[action.payload] = true;
      }
    },
    fetchEnd(state, action) {
      if (action.payload.constructor === Array) {
        action.payload.forEach((id) => {
          state.loading[id] = false;
        });
      } else {
        state.loading[action.payload] = false;
      }
    },
    setError(state, action) {
      state.error = action.payload;
    },
    clearError(state, action) {
      state.error = '';
    },
    setProducts(state, action) {
      if (action.payload.length > 0) {
        for (let productID in action.payload) {
          const product = action.payload[productID];
          state.products[product.id] = product;
        }
      }
    }
  }
});

export const fetchProducts = (productList, currency, locale) => (dispatch) => {
  return new Promise((resolve, reject) => {
    getProducts(
      productList,
      currency,
      '2a3b13e8-a80b-4795-853a-4cd52645919b',
      true,
      locale
    )
      .then((products) => {
        dispatch(setProducts(products));
        resolve(products);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

export const {
  setInitialized,
  fetchStart,
  fetchEnd,
  setError,
  clearError,
  setProducts
} = appSlice.actions;

export default appSlice.reducer;
